import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Urls from '../../components/Url/Urls';

 


export const CreditPurchaseApi = createApi({
  reducerPath: 'CreditPurchaseApi',
  baseQuery: fetchBaseQuery({ baseUrl:   Urls.creditPurchase.get }),
  endpoints: (builder) => ({
    getCreditPurchase: builder.query({
      query: () => '',
      transformResponse: (response, meta, arg) => {
        return response.data
      },
      invalidatesTags: ['productsApi'],
    }),
   
  }),
});

export const { useGetCreditPurchaseQuery } = CreditPurchaseApi;
